import { useNavigate } from "react-router-dom";
import { useEntrepriseAvancement } from "@src/societes/useEntrepriseAvancement";
import { GatewayInfoSocieteOrias } from "@conformite/gateway";
import { ConformiteSocieteList } from "./ConformiteSocieteList";

export function ConformiteSocieteListFormationContinueIas() {
  const navigate = useNavigate();
  const { getEntrepriseAvancementForAssujettiAxe } = useEntrepriseAvancement();

  return (
    <ConformiteSocieteList
      defaultFilters={{ categories: GatewayInfoSocieteOrias.CategorieIASList }}
      getFormAvancement={(entreprise) =>
        getEntrepriseAvancementForAssujettiAxe(
          entreprise,
          "formationContinueIas"
        )
      }
      title="Formation Continue IAS"
      onSocieteRedirect={(entreprise) => {
        navigate(`${entreprise.siren}?fromAxe`);
      }}
    />
  );
}
